export default __webpack_public_path__ + "static/media/2012-MH.d22a2ca5.jpg";